<script setup lang="ts">
import type { AppFlickerSize, AppFlickerBorderRadius } from '@libs/ui';
import { AppFlicker } from '@libs/ui';

const width: AppFlickerSize = '100%';
const height: AppFlickerSize = 'spacing-24';
const borderRadius: AppFlickerBorderRadius = 'border-radius-8';
</script>

<template>
  <div class="hotel-amenities-section-loader">
    <div class="title">
      {{ $t('filter.amenities.description') }}
    </div>
    <div class="hotel-amenities">
      <div class="amenities-group">
        <AppFlicker
          :width="width"
          :height="height"
          :border-radius="borderRadius"
        />
        <AppFlicker
          :width="width"
          :height="height"
          :border-radius="borderRadius"
        />
        <AppFlicker
          :width="width"
          :height="height"
          :border-radius="borderRadius"
        />
        <AppFlicker
          :width="width"
          :height="height"
          :border-radius="borderRadius"
        />
        <AppFlicker
          :width="width"
          :height="height"
          :border-radius="borderRadius"
        />
        <AppFlicker
          :width="width"
          :height="height"
          :border-radius="borderRadius"
        />
      </div>
    </div>
    <div class="link">
      <AppFlicker
        width="100%"
        height="line-heights-18"
        border-radius="border-radius-8"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.hotel-amenities-section-loader {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-16);

  .title {
    color: var(--color-secondary-40);
    @include font-heading-5;
  }

  .link {
    display: flex;
    width: 20%;
  }

  .hotel-amenities {
    display: flex;
    gap: var(--spacing-64);

    .amenities-group {
      display: flex;
      flex-flow: column;
      width: 35%;
      gap: var(--spacing-8);

      .hotel-amenity {
        display: flex;
        align-items: center;
        gap: var(--spacing-8);

        .amenity-text {
          color: var(--color-secondary-60);
          @include font-body-l-light;
        }
      }
    }
  }
}
</style>
